import Image from 'next/image'

import { constants } from '@/lib/constants'

type LoaderProps = {
  message?: string
}

export const Loader = ({ message = 'Loading...' }: LoaderProps) => (
  <div className="loader--search">
    <Image
      src={`${constants.imageHost.assets}/general/loading.gif`}
      alt="loading"
      height="75"
      width="75"
      rel="prefetch"
    />
    <p className="mt-2">{message}</p>
  </div>
)
